import {
  createExternalRouteRef,
  createRouteRef,
} from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'odp-techdocs',
});

export const readerRouteRef = createRouteRef({
  id: 'odp-techdocs:reader',
  params: ['namespace', 'kind', 'name'],
});

export const contributorExternalRouteRef = createExternalRouteRef({
  id: 'odp-techdocs:contributor',
  optional: true,
});
